// Module Import
//---------------------------------
import React, { useState } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import styled from 'styled-components'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import BrandBlades from '../../../assets/images/logo_bladeOrange.png'
import TypographyAtom from '../../atoms/typography/typography'
import Image from '../../atoms/images/images'
import ImageCut from '../../../assets/images/graphic_imageCut.svg'
import ImageCutGrey from '../../../assets/images/graphic_imageCutGrey.svg'
import Poster from '../../../assets/images/image_videoPoster.webp'
import TextHeader from '../TextHeader/TextHeader'
import muteIcon from '../../../assets/images/mute_outline_icon.svg'
import soundIcon from '../../../assets/images/sound_outline_icon.svg'
import { brandIvory, brandKhaki, brandOrange, brandWhite } from '../../../assets/consts/color'
import { secondaryFont } from '../../../assets/consts/fonts'
import ArticleDate from '../ArticleDate/ArticleDate'
import EmbeddedYouTubeVideo from '../EmbeddedYouTubeVideo/EmbeddedYouTubeVideo'
import ButtonAtom from "../../atoms/buttons/buttons";

// Component Import
//---------------------------------

// Styled Component Declarations
//---------------------------------

// Primary Masthead
const MastHeadWrapper = styled.header`
  align-items: end;
  border-radius: 4px;
  display: grid;
  height: 66vh;
  position: relative;
  z-index: 1;

  &:after {
    background-image: url(${ImageCut});
    background-repeat: no-repeat;
    background-size: 100%;
    bottom: 0;
    content: '';
    height: 60px;
    position: absolute;
    right: 0;
    width: 60px;
    z-index: 1;
  }

  &:before {
    background-image: url(${BrandBlades});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    bottom: -37px;
    content: '';
    height: 75px;
    position: absolute;
    right: 21px;
    width: 75px;
    z-index: 2;
  }

  @media only screen and (min-width: 48em) {
    height: 90vh;

    &:after {
      height: 60px;
      width: 60px;
    }

    &:before {
      bottom: -37px;
      height: 75px;
      right: 21px;
      width: 75px;
    }
  }
`

const CopyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  position: relative;
  z-index: 2;
  padding-left: 24px;

  &:before {
    background-color: ${brandOrange};
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    width: 4px;
  }
  
  h1 {
    color: ${brandWhite};
    margin: 0;
  }

  h2 {
    color: ${brandWhite};
    margin: 0;
  }
`

const ImageFilter = styled.div`
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 41.12%, #1d1d1d 100%);
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1;
`

// Primary Masthead
const MastHeadButtonWrapper = styled.div`
  align-items: end;
  border-radius: 4px;
  display: grid;
  height: 66vh;
  position: relative;
  z-index: 1;

  &:after {
    background-image: url(${ImageCut});
    background-repeat: no-repeat;
    background-size: 100%;
    top: 0;
    content: '';
    height: 60px;
    position: absolute;
    rotate: 180deg;
    left: 0;
    width: 60px;
    z-index: 1;
  }

  &:before {
    background-image: url(${BrandBlades});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    top: -37px;
    content: '';
    height: 75px;
    position: absolute;
    left: 21px;
    width: 75px;
    z-index: 2;
  }
  
  button {
    max-width: 250px;
    z-index: 2;
    margin-left: 24px;
    width: fit-content;
    justify-content: center;
  }

  @media only screen and (min-width: 48em) {
    height: 90vh;

    &:after {
      height: 60px;
      width: 60px;
    }

    &:before {
      bottom: -37px;
      height: 75px;
      right: 21px;
      width: 75px;
    }
  }
`

const ContentInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const CopyInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  position: relative;
  z-index: 2;
  padding-left: 24px;

  &:before {
    background-color: ${brandWhite};
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    width: 4px;
  }
  
  h1 {
    color: ${brandWhite};
    margin: 0;
  }

  h2 {
    color: ${brandWhite};
    margin: 0;
  }
`

// Secondary Masthead
const MastHeadWrapperInset = styled.header`
  align-items: end;
  border-radius: 4px;
  display: grid;
  height: 50vh;
  position: relative;
  z-index: 1;
  margin: 0 0 40px 0;

  &:after {
    background-image: url(${ImageCut});
    background-repeat: no-repeat;
    background-size: 100%;
    bottom: 0;
    content: '';
    height: 60px;
    position: absolute;
    right: 0;
    width: 60px;
    z-index: 1;
  }

  &:before {
    background-image: url(${BrandBlades});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    bottom: -37px;
    content: '';
    height: 75px;
    position: absolute;
    right: 21px;
    width: 75px;
    z-index: 2;
  }

  @media only screen and (min-width: 48em) {
    margin: 0 0 80px 0;
    &:after {
      height: 60px;
      width: 60px;
    }

    &:before {
      bottom: -37px;
      height: 75px;
      right: 21px;
      width: 75px;
    }
  }
`

const CopyWrapperInset = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding-left: 24px;
  position: relative;
  z-index: 3;

  &:before {
    background-color: ${brandOrange};
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    width: 4px;
  }

  h1 {
    color: ${brandWhite};
    font-family: ${secondaryFont};
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 67.2px */
    margin: 0;
  }

  h2 {
    color: ${brandWhite};
    font-family: ${secondaryFont};
    font-style: normal;
    font-weight: 300;
    line-height: 120%; /* 46.8px */
    margin: 0;
  }
`

const InsetImageFilter = styled.div`
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 41.12%, #1d1d1d 100%);
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1;
`

// Tertiary Masthead
const SubLevelMastHeadWrapper = styled.header`
  align-items: flex-start;
  align-self: stretch;
  background: ${brandIvory};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  flex: 1 0 0;
  gap: 16px;
  justify-content: center;
  margin: 0 0 80px 0;
  padding: 40px;
  position: relative;

  h1 {
    color: ${brandOrange};
    margin: 0;
  }

  h2 {
    margin: 0;
  }

  &:after {
    background-image: url(${ImageCut});
    background-repeat: no-repeat;
    background-size: 100%;
    bottom: 0;
    content: '';
    height: 60px;
    position: absolute;
    right: 0;
    width: 60px;
    z-index: 1;
  }

  &:before {
    background-image: url(${BrandBlades});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    bottom: -37px;
    content: '';
    height: 75px;
    position: absolute;
    right: 21px;
    width: 75px;
    z-index: 2;
  }

  @media only screen and (min-width: 48em) {
    height: 25vh;
    padding: 80px;
    margin: 0 0 160px 0;

    &:after {
      height: 60px;
      width: 60px;
    }

    &:before {
      bottom: -37px;
      height: 75px;
      right: 21px;
      width: 75px;
    }
  }
`

// Text Masthead
const TextMastHeadWrapper = styled.header`
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  flex: 1 0 0;
  gap: 8px;
  justify-content: center;
  margin: 100px 0 0;
  padding-left: 24px;
  position: relative;
  border-left: 3px solid ${brandOrange};

  h1 {
    //color: ${brandOrange};
    margin: 0;
  }

  h2 {
    margin: 0;
  }
  
  
  @media only screen and (min-width: 48em) {
    margin: 160px 0 0;
    gap: 16px;
  }
`

// Support Guide Masthead
const SupportGuideMastHeadWrapper = styled.header`
  border-radius: 4px 0px 0px 4px;
  display: flex;
  flex-direction: column;
  position: relative;

  margin-bottom: 80px;

  h1 {
    font-size: 26px;
    line-height: 150%;
    margin: 0;
    color: ${brandOrange};

    @media only screen and (min-width: 48em) {
      font-size: 39px;
    }
  }

  h2 {
    font-size: 24px;
    line-height: 150%;
    margin: 0;

    @media only screen and (min-width: 48em) {
      font-size: 34px;
    }
  }
`

// Data security Masthead
const DataSecurityMastHeadWrapper = styled.header`
  border-radius: 4px 0px 0px 4px;
  display: flex;
  flex-direction: column;
  position: relative;

  margin-bottom: 80px;

  &:before {
    background-color: ${brandOrange};
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    width: 4px;
  }
  
  h1 {
    font-size: 26px;
    line-height: 150%;
    margin: 0;
    // color: ${brandOrange};
    padding-left: 24px;
    
    @media only screen and (min-width: 48em) {
      font-size: 39px;
    }
  }

  h2 {
    font-size: 24px;
    line-height: 150%;
    margin: 0;

    @media only screen and (min-width: 48em) {
      font-size: 34px;
    }
  }
`

// Blog Masthead
const BlogPageMastHeadWrapper = styled.header`
  border-radius: 4px 0px 0px 4px;
  display: flex;
  flex-direction: column;
  position: relative;

  h1 {
    font-size: 26px;
    line-height: 150%;
    margin: 0;

    @media only screen and (min-width: 48em) {
      font-size: 39px;
    }
  }

  h2 {
    line-height: 150%;
    margin: 0;
  }

  & > p {
    margin-bottom: 40px;
    font-size: 20px;
  }

  .category-and-date {
    margin-bottom: 16px;

    @media only screen and (min-width: 48em) {
      margin-bottom: 24px;
    }

    p {
      font-size: 14px;

      @media only screen and (min-width: 48em) {
        font-size: 20px;
      }
    }
  }

  .video-wrapper {
    margin: 0 0 16px 0;

    @media only screen and (min-width: 48em) {
      margin-bottom: 40px;
    }

    @media only screen and (min-width: 90em) {
      width: 60%;
    }
  }
`

const BlogPageMastheadImageWrapper = styled.div`
  border-radius: 4px;
  display: flex;
  position: relative;
  margin: 0 0 16px 0;

  @media only screen and (min-width: 48em) {
    margin-bottom: 40px;
  }

  @media only screen and (min-width: 90em) {
    width: 60%;
  }

  .gatsby-image-wrapper img {
    height: auto;
  }

  img {
    border-radius: 4px;
  }

  &:before {
    background-image: url(${ImageCut});
    background-repeat: no-repeat;
    background-size: 100%;
    content: '';
    height: 60px;
    position: absolute;
    right: 0;
    top: 0;
    transform: rotate(-90deg);
    width: 60px;
    z-index: 1;
  }

  &:after {
    background-image: url(${ImageCut});
    background-repeat: no-repeat;
    background-size: 100%;
    bottom: 0;
    content: '';
    height: 60px;
    left: 0;
    position: absolute;
    transform: rotate(90deg);
    width: 60px;
    z-index: 1;
  }
`

// Video Masthead
const VideoMasthead = styled.header`
  align-items: flex-end;
  background-color: grey;
  display: flex;
  height: 66vh;
  padding: 40px 0;
  position: relative;
  width: 100%;
  z-index: 1;

  &:after {
    background-image: url(${ImageCutGrey});
    background-repeat: no-repeat;
    background-size: 100%;
    bottom: 0;
    content: '';
    height: 30px;
    position: absolute;
    right: 0;
    width: 30px;
    z-index: 1;
  }

  &:before {
    background-image: url(${BrandBlades});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    bottom: -37px;
    content: '';
    height: 75px;
    position: absolute;
    right: 21px;
    width: 75px;
    z-index: 2;
  }

  @media only screen and (min-width: 48em) {
    padding: 80px 0;
    height: 90vh;

    &:after {
      height: 60px;
      width: 60px;
    }

    &:before {
      bottom: -37px;
      height: 75px;
      right: 21px;
      width: 75px;
    }
  }
`

const VideoMastheadMediaWrapper = styled.div`
  bottom: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  video {
    height: 100%;
    object-fit: cover;
    @media (min-width: 76em) {
      width: 100%;
    }
  }

  &:after {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 41.12%, #1d1d1d 100%);
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`

const VideoMastheadCopyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 0 24px;
  position: relative;
  width: 100%;

  &:before {
    background-color: ${brandOrange};
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    top: 0;
    width: 4px;
  }

  h1 {
    color: ${brandWhite};
    margin: 0 0 8px 0;
  }

  h2 {
    color: ${brandWhite};
    margin: 0;
  }
`

const VideoMuteIconWrapper = styled.div`
  img.mute-toggle-icon {
    position: absolute;
    top: 96px;
    right: 48px;
    width: 40px;
    height: 40px;
    z-index: 111;
    filter: grayscale(100%);
  }

  @media only screen and (min-width: 64em) {
    img.mute-toggle-icon {
      position: absolute;
      bottom: 64px;
      right: 64px;
      width: 40px;
      height: 40px;
      z-index: 111;
      filter: grayscale(100%);
    }
  }
`

const StyledGatsbyImage = styled(GatsbyImage)`
  grid-area: 1/1;
  height: 100%;
  width: 100%;
  border-radius: 4px;
`
const ContentWrapper = styled.div`
  grid-area: 1/1;
  position: relative;
`

const ContentWrapperPrimary = styled(ContentWrapper)`
  padding: 0 0 40px 0;

  @media only screen and (min-width: 48em) {
    padding: 0 0 80px 0;
  }
`

const ContentWrapperSecondary = styled(ContentWrapper)`
  padding: 40px;
`
const CategoryLabel = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
  padding: 4px 10px;

  background-color: ${brandIvory};

  p {
    color: ${brandKhaki};
  }
`

// Component Export
//---------------------------------

// Homepage Masthead
export default function MastHead({
  imgSrc,
  title,
  subtitle,
  type,
  imgAltTag = 'insert alt tag',
  buttonText,
  onClick,
  VideoSrc,
  className,
  titleField,
  subtitleField,
  imagePosition,
  articleCategory,
  articleAuthor,
  articleUpdatedDate,
  articlePublishedDate,
  snippetYouTubeLink,
  snippetVideoFile,
  eventTime
}) {
  const [mutedStatus, muteStatusChange] = useState(true)
  const [iconSrc, changeIconSrc] = useState(muteIcon)

  const muteToggle = () => {
    if (mutedStatus) {
      changeIconSrc(soundIcon)
      muteStatusChange(false)
    } else {
      changeIconSrc(muteIcon)
      muteStatusChange(true)
    }
  }

  return (
    <>
      {type === 'Video' && (
        <VideoMasthead>
          <VideoMastheadMediaWrapper>
            <VideoMuteIconWrapper>
              <img
                className="mute-toggle-icon"
                src={iconSrc}
                onClick={muteToggle}
                alt="Mute Video"
              />
            </VideoMuteIconWrapper>
            <video poster={Poster} autoPlay controls={false} loop muted={mutedStatus} playsInline>
              <source src={VideoSrc} type="video/webm" />
            </video>
          </VideoMastheadMediaWrapper>
          <div className="outer">
            <div className="inner">
              <VideoMastheadCopyWrapper>
                <TypographyAtom type="H1" copy={title} weight="Bold" />
                <TypographyAtom type="H2" copy={subtitle} weight="Thin" />
              </VideoMastheadCopyWrapper>
            </div>
          </div>
        </VideoMasthead>
      )}
      {type === 'Primary' && (
          <div className={className}>
            <MastHeadWrapper>
              <StyledGatsbyImage
                layout="fullWidth"
                aspectRatio={3 / 1}
                alt=""
                image={imgSrc}
                formats={['auto', 'webp', 'avif']}
                loading="eager"
                objectPosition={imagePosition || '50% 50%'}
              />
              <ContentWrapperPrimary>
                <div className="outer">
                  <div className="inner">
                    <CopyWrapper>

                      <TypographyAtom type="H1" copy={title} weight="Bold" />
                      <TypographyAtom type="H2" copy={subtitle} weight="Thin" />
                    </CopyWrapper>
                  </div>
                </div>
              </ContentWrapperPrimary>
              <ImageFilter />
            </MastHeadWrapper>
          </div>
      )}
      {type === 'PrimaryWithButton' && (
          <MastHeadButtonWrapper className={className}>
            <StyledGatsbyImage
                layout="fullWidth"
                aspectRatio={3 / 1}
                alt=""
                image={imgSrc}
                formats={['auto', 'webp', 'avif']}
                loading="eager"
                objectPosition={imagePosition || '50% 50%'}
            />
            <ContentWrapperPrimary>
              <div className="outer">
                <div className="inner">
                  <ContentInnerWrapper>
                    <CopyInnerWrapper>
                      <TypographyAtom type="H1" copy={title} weight="Bold" />
                      <TypographyAtom type="H2" copy={subtitle} weight="Thin" />
                    </CopyInnerWrapper>
                    <ButtonAtom buttonType={"Secondary Button Without Arrow"} buttonCopy={buttonText} onClick={onClick}/>
                  </ContentInnerWrapper>
                </div>
              </div>
            </ContentWrapperPrimary>
            <ImageFilter />
          </MastHeadButtonWrapper>
      )}
      {type === 'Secondary' && (
        <div className="outer">
          <div className="inner">
            <MastHeadWrapperInset className={className}>
              <StyledGatsbyImage
                layout="fullWidth"
                aspectRatio={3 / 1}
                alt=""
                image={imgSrc}
                formats={['auto', 'webp', 'avif']}
                loading="eager"
              />
              <ContentWrapperSecondary>
                <CopyWrapperInset>
                  <TypographyAtom type="H1" copy={title} weight="Bold" />
                  <TypographyAtom type="H2" copy={subtitle} weight="Thin" />
                </CopyWrapperInset>
              </ContentWrapperSecondary>
              <InsetImageFilter />
            </MastHeadWrapperInset>
          </div>
        </div>
      )}
      {type === 'Tertiary' && (
        <SubLevelMastHeadWrapper>
          <TypographyAtom type="H1" copy={title} weight="Light" />
          <TypographyAtom type="H2" copy={subtitle} weight="Thin" />
        </SubLevelMastHeadWrapper>
      )}
      {type === 'Text' && (
          <div className={`outer ${className}`}>
            <TextMastHeadWrapper>
              <TypographyAtom type="H1" copy={title} weight="Light" />
              <TypographyAtom type="H2" copy={subtitle} weight="Thin" />
            </TextMastHeadWrapper>
          </div>
      )}
      {type === 'Blog' && (
        <BlogPageMastHeadWrapper>
          {imgSrc && (
            <BlogPageMastheadImageWrapper>
              <Zoom zoomMargin={45} classDialog="custom-zoom">
                <Image imgSrc={imgSrc} altTag={imgAltTag} hasFrame="No Frame" aspectRatio="16/9" />
              </Zoom>
            </BlogPageMastheadImageWrapper>
          )}
          {snippetYouTubeLink && !imgSrc && !snippetVideoFile && (
            <div className="video-wrapper">
              <EmbeddedYouTubeVideo youTubeLink={snippetYouTubeLink} />
            </div>
          )}
          {snippetVideoFile && !imgSrc && !snippetYouTubeLink && (
            <div className="video-wrapper">
              <video width="100%" height="auto" controls>
                <source src={snippetVideoFile} type="video/mp4" />
              </video>
            </div>
          )}
          <div className="flex between-xs top-xs category-and-date">
            {articleCategory && articleCategory !== 'Snippets' && (
              <CategoryLabel>
                <TypographyAtom type="P" copy={articleCategory} weight="Regular" />
              </CategoryLabel>
            )}
            <ArticleDate
              updatedDate={articleUpdatedDate}
              publishedDate={articlePublishedDate}
              updatedDateLabel="Updated on"
              publishedDateLabel="Published on"
              articleAuthor={articleCategory === 'Snippets' ? '' : articleAuthor}
            />
          </div>

          <TextHeader
            titleField={titleField}
            subtitleField={subtitleField}
            title={title}
            subtitle={subtitle}
            articleTitle
          />
          {/* <TypographyAtom
          type="Display"
          copy={title}
          weight="Light"
        />
        <TypographyAtom
          type="H2"
          copy={subtitle}
          weight="Thin"
        /> */}
        </BlogPageMastHeadWrapper>
      )}
      {type === 'Event' && (
          <BlogPageMastHeadWrapper>
            {imgSrc && (
                <BlogPageMastheadImageWrapper>
                  <Zoom zoomMargin={45} classDialog="custom-zoom">
                    <Image imgSrc={imgSrc} altTag={imgAltTag} hasFrame="No Frame" aspectRatio="16/9" />
                  </Zoom>
                </BlogPageMastheadImageWrapper>
            )}
            <div className="flex between-xs top-xs category-and-date">
              <TypographyAtom type="P" weight="Regular" color="Orange" copy={eventTime} />
            </div>

            <TextHeader
                titleField={titleField}
                subtitleField={subtitleField}
                title={title}
                subtitle={subtitle}
                articleTitle
            />
          </BlogPageMastHeadWrapper>
      )}
      {type === 'SupportGuides' && (
        <SupportGuideMastHeadWrapper>
          {imgSrc && (
            <BlogPageMastheadImageWrapper>
              <Image imgSrc={imgSrc} altTag={imgAltTag} hasFrame="No Frame" aspectRatio="16/9" />
            </BlogPageMastheadImageWrapper>
          )}
          <TypographyAtom type="H1" copy={title} weight="Light" />
          <TypographyAtom type="H2" copy={subtitle} weight="Thin" />
        </SupportGuideMastHeadWrapper>
      )}
      {type === 'DataSecurity' && (
          <DataSecurityMastHeadWrapper>
            <TypographyAtom type="H1" copy={title} weight="Light" />
          </DataSecurityMastHeadWrapper>
      )}
    </>
  )
}
